import { InitialConfig } from '@loctypes'
import { getConfig } from '@services/context'

type InitialConfigCallbackParams = Pick<InitialConfig, 'onLoad' | 'onCreated' | 'onLinked' | 'onUnlinked' | 'onToggle'>

export const initialConfigCallback = (callbackName: keyof InitialConfigCallbackParams, args?: any): void => {
  const callback = getConfig(callbackName)

  if (typeof callback === 'function') {
    callback(args)
  }
}
